// Put your applicaiton javascript here

$('#menu-toggle').click(function () {
  $('#navbox').toggleClass('is-open');
  $('body').toggleClass('opennav');
  $('#searchbox').removeClass('is-open');
  $(this).toggleClass('active');
  $('body').toggleClass('navopen');
});

$('#search-toggle').click(function () {
  $('#navbox').removeClass('is-open');
  $('body').removeClass('opennav');
  $('#searchbox').toggleClass('is-open');
  $(this).toggleClass('active');
});

$('#acc-toggle').click(function () {
  $('.acc-dd').slideToggle();
  $(this).toggleClass('active');
});

$('.acc-toggle').click(function () {
  $('#navbox').removeClass('is-open');
  $('body').removeClass('opennav');
  $('.acc-dd').toggle();
  $(this).toggleClass('active');
});

$('#PageContainer').click(function () {
  var id = $(this).id;
  if (id != 'acc-toggle' && id != 'acc-dd') {
    $('.acc-dd').hide();
    $('#acc-toggle').removeClass('active');
  }
});

$('.ptab').click(function () {
  if ($(window).width() < 768) {
    if ($(this).hasClass('is-open')) {
      $(this).removeClass('is-open');
      $('.' + $(this).data('tabtarget')).slideToggle();
    } else {
      $('.ptab').removeClass('is-open');
      $('.pt-content').hide();
      $('.' + $(this).data('tabtarget')).slideToggle();
      $(this).addClass('is-open');
    }
  } else {
    $('.ptab').removeClass('is-open');
    $('.pt-content').hide();
    $('.' + $(this).data('tabtarget')).show();
    $(this).addClass('is-open');
  }
});

$('button.site-nav__link.site-nav__link--main.site-nav__link--button').click(function () {
  $('.arrwopen').not(this).removeClass('arrwopen');
  $(this).toggleClass('arrwopen');
  $('.site-nav__dropdown:not(#' + $(this).attr('aria-controls') + ')').hide();
  $(this).toggleClass('nav-open');
  $(this).removeClass('nav-open');
  $('#' + $(this).attr('aria-controls')).slideToggle();
  $('#' + $(this).attr('aria-controls')).toggleClass('navopen');
});
$('#share-trigger').click(function () {
  $('#st-1').slideToggle();
});

function stockmsg(textlead) {
  $('#stocklevels').remove();
  var stockmsgflag = false;
  $('#tomit_inventory_list li').each(function () {
    let invlocation = $(this).find('.location').text().trim();
    let icount = $(this).find('.stockCount').text().trim();    
    if (invlocation == 'DM1' && +icount > 2) {      
      $('.freeshippingtext').html('Usually Ships Out in <span id="leadtime">1 Business Day</span>');
      $('.freeshippingtext').hide();
      if (+icount > 50) {
        icount = 50;
      }
      $('#stocklevels').remove();
      $('<div id="stocklevels"><span>In Stock!</span> Usually ships in 1-2 business days.</div>').insertBefore(
        '.freeshippingtext'
      );
      stockmsgflag = true;
    }
    if (
      ['BRASSTECH', 'NATIVETRAILS', 'AMBA', 'APTATIONS', 'CHEVIOT', 'KRAUS', 'WESTBRASS'].includes(invlocation) &&
      +icount > 2
    ) {      
      $('.freeshippingtext').html('Usually Ships Out in <span id="leadtime">1 Business Day</span>');
      $('.freeshippingtext').hide();
      if (+icount > 50) {
        icount = 50;
      }
      $('#stocklevels').remove();
      $('<div id="stocklevels"><span>In Stock!</span> Usually ships within 5-7 business days.</div>').insertBefore(
        '.freeshippingtext'
      );
      stockmsgflag = true;
    }
  });
  if (stockmsgflag == false) {
    if (textlead == 'Please contact us for Lead Time') {
      $('.freeshippingtext').show();
      $('.freeshippingtext').html(textlead);
    } else {
      $('.freeshippingtext').show();
      $('.freeshippingtext').html('Usually Ships within <span id="leadtime">' + textlead + '</span>');
    }
  }
}

function calcdays() {
  var newlead = $('.shiprow[data-sku="' + $('.variant-sku').html() + '"]').data('shippmsg');

  if (newlead == null) {
    newlead = $('.shiprow[data-sku="' + $('.mpn').text() + '"]').data('shippmsg');
  }

  if (newlead == null || $('.shiprow').length == 1) {
    newlead = $('#simplelt').data('leadtime');
  }

  var textlead = '';

  if (newlead == '1') {
    textlead = '1-3 Days';
  } else if (newlead == '2') {
    textlead = '2-4 Days';
  } else if (newlead == '3') {
    textlead = '3-5 Days';
  } else if (newlead == '4') {
    textlead = '4-6 Days';
  } else if (newlead == '5') {
    textlead = '5-7 Days';
  } else if (newlead == '7') {
    textlead = '7-10 Days';
  } else if (newlead == '14') {
    textlead = '2-3 Weeks';
  } else if (newlead == '21') {
    textlead = '3-4 Weeks';
  } else if (newlead == '28') {
    textlead = '4-6 Weeks';
  } else if (newlead == '42') {
    textlead = '6-8 Weeks';
  } else if (newlead == '56') {
    textlead = '8-10 Weeks';
  } else if (newlead == '91') {
    textlead = '13-15 Weeks';
  } else if (newlead == '98') {
    textlead = '14-15 Weeks';
  } else if (newlead == '105') {
    textlead = '15-17 Weeks';
  } else if (newlead == '112') {
    textlead = '16-17 Weeks';
  } else if (newlead == '133') {
    textlead = '16-19 Weeks';
  } else if (newlead == '154') {
    textlead = '18-22 Weeks';
  } else if (newlead == '140') {
    textlead = '20-26 Weeks';
  } else if (newlead == '252') {
    textlead = '36-40 Weeks';
  } else if (newlead > 0) {
    textlead = newlead + ' Days';
  } else {
    textlead = 'Please contact us for Lead Time';
  }

  stockmsg(textlead);

  setInterval(function () {
    stockmsg(textlead);
  }, 100);
}

$('.variant-sku').bind('DOMSubtreeModified', function () {
  if ($(this).text().length > 0) {
    calcdays();
  }
});

if (!$.trim($('.additional-info').html()).length) {
  $('#ptabs').addClass('twotabs');
}
$(document).ready(function () {
  if ($(window).width() > 767) {
    $('.ptab.ptab-desc').addClass('is-open');
    $('.pcontent.pt-content.pt-desc').show();
  }
  calcdays();
  var swatchtoclick = $('#SingleOptionSelector-0').val();
  $('input[value="' + swatchtoclick + '"]').trigger('click');

  if (typeof $('span#ProductPrice').html() !== 'undefined') {
    var cprice = $('span#ProductPrice').html().replace('$', '');
    cprice = cprice.replace('From: ', '');
    if (+cprice < 99) {
      $('#freeshiptest').html('FREE SHIPPING OVER $99');
    }
  }
});

function optiontable() {
  if ($('.option-list').length == 1) {
    var productoptions = $('.option-list').text();
    productoptions = productoptions.substring(1);
    productoptions = productoptions.split('|');
    console.log(productoptions);
    var sku = productoptions[0].split(',');
    var finish = productoptions[1].substring(1).split(',');
    var msrp = productoptions[2].substring(1).split(',');
    var price = productoptions[3].substring(1).split(',');
    var saleprice = productoptions[4].substring(1).split(',');
    if (typeof productoptions[5] != 'undefined') {
      var variantid = productoptions[5].substring(1).split(',');
    } else {
      var variantid = new Array(sku.length);
    }
    if (typeof productoptions[6] != 'undefined') {
      var ships = productoptions[6].substring(1).split(',');
    } else {
      var ships = new Array(sku.length);
    }
    if (typeof productoptions[7] != 'undefined') {
      var mpn = productoptions[7].substring(1).split(',');
    } else {
      var mpn = new Array(sku.length);
    }

    var lowprice = 9999;
    var lowmsrp = 9999;
    var shippingtable = '';

    var i;
    var buildtable;
    $('.option-list').hide();
    for (i = 0; i < sku.length; i++) {
      console.log(productoptions[6]);
      if (typeof productoptions[5] === 'undefined') {
        variantid[i] = '#';
      }
      if (typeof productoptions[6] === 'undefined') {
        ships[i] = 0;
      }
      if (+saleprice[i] > 0) {
        buildtable +=
          '<tr data-mpn="' +
          mpn[i] +
          '" data-vid="' +
          variantid[i] +
          '" class="pdrow onsale" data-saleprice="' +
          saleprice[i] +
          '" data-finish="' +
          finish[i] +
          '" data-pdsku="' +
          sku[i] +
          '" data-pdprice=' +
          price[i] +
          ' data-pdmsrp=' +
          msrp[i] +
          '><td>' +
          mpn[i] +
          '</td>' +
          '<td>' +
          finish[i] +
          '</td>' +
          '<td>$' +
          Number(msrp[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
          '</td>' +
          '<td><strike>$' +
          Number(price[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
          '</strike> On Sale $' +
          Number(saleprice[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
          '</td></tr>';
        shippingtable +=
          '<div class="shiprow" data-shippmsg="' + ships[i] + '" data-sku="' + sku[i] + '">' + ships[i] + '</div>';
      } else {
        buildtable +=
          '<tr data-mpn="' +
          mpn[i] +
          '" data-vid="' +
          variantid[i] +
          '" class="pdrow" data-pdsku="' +
          sku[i] +
          '" data-pdprice=' +
          price[i] +
          ' data-pdmsrp=' +
          msrp[i] +
          ' data-finish="' +
          finish[i] +
          '"><td>' +
          mpn[i] +
          '</td>' +
          '<td>' +
          finish[i] +
          '</td>' +
          '<td>$' +
          Number(msrp[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
          '</td>' +
          '<td>$' +
          Number(price[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
          '</td></tr>';
        shippingtable +=
          '<div class="shiprow" data-shippmsg="' + ships[i] + '" data-sku="' + sku[i] + '">' + ships[i] + '</div>';
      }
      if (price[i] < lowprice) {
        lowprice = price[1];
      }
      if (msrp[i] < lowmsrp) {
        lowmsrp = msrp[1];
      }
    }
    $('#productdetails').html(
      '<thead><tr><td>MPN</td><td>Finish</td><td>Retail Price</td><td>Our Price</td></tr></thead>' + buildtable
    );
    $('#PageContainer').append('<div class="shiptable" style="display:none;">' + shippingtable + '</div>');

    /*console.log(lowmsrp);
        console.log(lowprice);
        $('#ProductPrice').html('From: $'+lowprice);
        $('#ComparePrice').html('$'+lowmsrp);*/
  } else if ($('.option-list').length > 1) {
    $('.option-list').each(function () {
      var productoptions = $(this).text();
      productoptions = productoptions.substring(1);
      productoptions = productoptions.split('|');

      var sku = productoptions[0].split(',');
      var finish = productoptions[1].substring(1).split(',');
      var msrp = productoptions[2].substring(1).split(',');
      var price = productoptions[3].substring(1).split(',');
      var saleprice = productoptions[4].substring(1).split(',');
      if (typeof productoptions[5] != 'undefined') {
        var variantid = productoptions[5].substring(1).split(',');
      } else {
        var variantid = new Array(sku.length);
      }
      if (typeof productoptions[6] != 'undefined') {
        var ships = productoptions[6].substring(1).split(',');
      } else {
        var ships = new Array(sku.length);
      }
      var lowprice = 9999;
      var lowmsrp = 9999;
      var shippingtable = '';

      var i;
      var buildtable;
      $('.option-list').hide();
      for (i = 0; i < sku.length; i++) {
        console.log(sku[i]);
        if (typeof productoptions[5] === 'undefined') {
          variantid[i] = '#';
        }
        if (typeof productoptions[6] === 'undefined') {
          ships[i] = 0;
        }
        if (+saleprice[i] > 0) {
          buildtable +=
            '<tr data-vid="' +
            variantid[i] +
            '" class="pdrow onsale" data-saleprice="' +
            saleprice[i] +
            '" data-finish="' +
            finish[i] +
            '" data-pdsku="' +
            sku[i] +
            '" data-pdprice=' +
            price[i] +
            ' data-pdmsrp=' +
            msrp[i] +
            '><td>' +
            sku[i] +
            '</td>' +
            '<td>' +
            finish[i] +
            '</td>' +
            '<td>$' +
            Number(msrp[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
            '</td>' +
            '<td><strike>$' +
            Number(price[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
            '</strike> On Sale $' +
            Number(saleprice[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
            '</td></tr>';
          shippingtable +=
            '<div class="shiprow" data-shippmsg="' + ships[i] + '" data-sku="' + sku[i] + '">' + ships[i] + '</div>';
        } else {
          buildtable +=
            '<tr data-vid="' +
            variantid[i] +
            '" class="pdrow" data-pdsku="' +
            sku[i] +
            '" data-pdprice=' +
            price[i] +
            ' data-pdmsrp=' +
            msrp[i] +
            ' data-finish="' +
            finish[i] +
            '"><td>' +
            sku[i] +
            '</td>' +
            '<td>' +
            finish[i] +
            '</td>' +
            '<td>$' +
            Number(msrp[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
            '</td>' +
            '<td>$' +
            Number(price[i]).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
            '</td></tr>';
          shippingtable +=
            '<div class="shiprow" data-shippmsg="' + ships[i] + '" data-sku="' + sku[i] + '">' + ships[i] + '</div>';
        }
        if (price[i] < lowprice) {
          lowprice = price[1];
        }
        if (msrp[i] < lowmsrp) {
          lowmsrp = msrp[1];
        }
      }

      $('<div class="shiptable" style="display:none;">' + shippingtable + '</div>').insertAfter($('#PageContainer'));

      /*console.log(lowmsrp);
          console.log(lowprice);
          $('#ProductPrice').html('From: $'+lowprice);
          $('#ComparePrice').html('$'+lowmsrp);*/
    });
  } else {
    $('table#productdetails').hide();
  }

  if ($('.specifications').length) {
    $('.specifications').appendTo('.pspectext');
  } else {
    $('.ptab-spec').hide();
  }

  function commas(str) {
    return str.replace(/.(?=(?:.{3})+$)/g, '$&,');
  }

  if ($('.additional-info').length) {
    $('.additional-info').appendTo('.pinfotext');
  } else {
    $('.ptab-info').hide();
  }
  $('.pdrow').on('click', function () {
    var urlsplit = window.location.pathname.split('?');
    document.location = urlsplit + '?variant=' + $(this).data('vid');
  });
  if (window.location.href.indexOf('variant') > -1 && $('.pdrow').length > 0) {
    var variantid = window.location.href.split('?variant=');

    if (variantid[1].indexOf('&gclid') > -1) {
      var varsplit = variantid[1].split('&gclid');
      var price = $('.pdrow[data-vid="' + varsplit[0] + '"]').data('pdprice');
      var msrp = $('.pdrow[data-vid="' + varsplit[0] + '"]').data('pdmsrp');
      var sku = $('.pdrow[data-vid="' + varsplit[0] + '"]').data('mpn');
      $('#ProductPrice').html('$' + price.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
      $('#ComparePrice').html('$' + msrp.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
      $('.variant-sku').html(sku);
    } else {
      var price = $('.pdrow[data-vid="' + variantid[1] + '"]').data('pdprice');
      var msrp = $('.pdrow[data-vid="' + variantid[1] + '"]').data('pdmsrp');
      var sku = $('.pdrow[data-vid="' + variantid[1] + '"]').data('mpn');
      price = Number(price);
      msrp = Number(msrp);
      $('#ProductPrice').html('$' + price.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
      $('#ComparePrice').html('$' + msrp.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
      $('.variant-sku').html(sku);
    }
  }
}
optiontable();

$(document).click(function (event) {
  $target = $(event.target);
  if (!$target.closest('#navbox').length) {
    $('.arrwopen').removeClass('arrwopen');
    $('.site-nav__dropdown').hide();
  }

  /*if (window.location.href.indexOf("?variant") > -1) {
          $('#SingleOptionSelector-0 option').attr('selected', false);
          $('#SingleOptionSelector-0').prop("selectedIndex", 0);
          $('.swatch input').attr('checked', false);
        }*/
});

var lastScrollTop = 0;
var startheight = $('#header').height();

$(window).scroll(function (event) {
  var st = $(this).scrollTop();
  var newheight = $('#header').height();

  console.log();
  if ($(this).scrollTop() > 140 && $(window).width() < 980) {
    $('body').addClass('mobscroll');
    $('#toppromobar').hide();
    $('#store-logo').hide();
    /*newheight = $('#header').height();        
        $('body').css('padding-top', newheight+'px');*/
    lastScrollTop = st;
  } else {
    $('body').removeClass('mobscroll');
    $('#toppromobar').show();
    $('#store-logo').show();
    /*newheight = $('#header').height();                */
  }
});

$(document).on('click', '.ss-swatch', function () {
  $('.ss-swatch').removeClass('selected');
  $(this).addClass('selected');
});

if ($('.template-collection').length > 0) {
  $('.section-header').prependTo('section.content');
  /* $('.breadcrumb').prependTo('section.content'); */
}

if ($('.collectionlink').length > 0) {
  var collectionlink = $('.collectionlink').html();
  collectionlink = collectionlink.replace(' ', '$2520');
  $('.collectionlink').attr('href', '/search?view=spring&q#/filter:mfield_details_collection:' + collectionlink);
}

function setHeights() {
  var windowwidth = $(window).width();
  if (windowwidth > 959) {
    var rowcount = 4;
  } else if (windowwidth > 767) {
    var rowcount = 3;
  } else if (windowwidth > 767) {
    var rowcount = 2;
  } else {
    var rowcount = 1;
  }

  var numberofitems = $('li.ss-item').length;
  var totalsets = numberofitems / rowcount;
  var itemsets = 1;
  var highheight = 0;
  var cindex = 1;

  $('li.ss-item').each(function (index, element) {
    $(this).addClass('heightset-' + itemsets);

    if (cindex % rowcount == 0) {
      itemsets = itemsets + 1;
    }
    cindex++;
  });
  let i = 1;
  while (i < totalsets) {
    var highheight = 0;
    $('.heightset-' + i).each(function (index, element) {
      if ($(this).find('.itemtitle a').height() > highheight) {
        highheight = $(this).find('.itemtitle a').height();
        $('.heightset-' + i)
          .find('.itemtitle')
          .css('max-height', highheight);
      }
    });
    i++;
  }
}

setInterval(function () {
  if ($('li.ss-item .itemtitle a')) {
    setHeights($(window).width());
  }
  $('.ss-swatch').each(function () {
    let newclass = $(this).attr('class');
    if ($(this).attr('class').indexOf('&') >= 0) {
      newclass = $(this).attr('class').replace('-&-', '-');
      $(this).attr('class', newclass);
    }
  });
}, 1000); // check every 100ms

$(window).resize(function () {
  if ($(window).width() < 768) {
    $('#cdesc').appendTo('#Collection .content');
  } else {
    $('#cdesc').insertAfter('#ctitle');
  }
});

$('body').on('click', '.bold_option_swatch .bold_option_value', function () {
  $(this).closest('.bold_option_swatch').find('.ptitle').remove();
  var targettitle =
    '<span class="ptitle"> - ' +
    $(this).find('.bold_option_value_title').html() +
    ' ' +
    $(this).find('.bold_option_value_price').html() +
    '</span>';
  $(this).closest('.bold_option_swatch').children('.bold_option_title').append(targettitle.replace('undefined', ''));
});

$(document).ready(function () {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function () {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    } else {
      alert('You must agree with the terms and conditions of sales to check out.');
      return false;
    }
  });

  var inter = setInterval(function () {
    if ($('.bold_options.bold_options_loaded').hasClass('option-active')) {
      if ($('bold_tooltip:nth(0)').hasClass('aictv')) {
        clearInterval(inter);
      } else {
        $('.bold_options.bold_options_loaded').removeClass('option-active');
      }
    } else {
      $('.bold_options.bold_options_loaded').addClass('option-active');

      $(
        '.product-single__meta .bold_options.bold_options_loaded .bold_option.bold_option_dropdown, .product-single__meta .bold_options.bold_options_loaded .bold_option.bold_option_uploadfile, .product-single__meta .bold_options.bold_options_loaded .bold_option.bold_option_telephone, .product-single__meta .bold_options.bold_options_loaded .bold_option.bold_option_date, .product-single__meta .bold_options.bold_options_loaded .bold_option.bold_option_color, .product-single__meta .bold_options.bold_options_loaded .bold_option.bold_option_email, .product-single__meta .bold_options.bold_options_loaded .bold_option.bold_option_number, .product-single__meta .bold_options.bold_options_loaded .bold_option.bold_option_textboxmulti, .product-single__meta .bold_options.bold_options_loaded .bold_option.bold_option_textarea, .product-single__meta .bold_options.bold_options_loaded .bold_option.bold_option_textbox, .product-single__meta .bold_options.bold_options_loaded .bold_option.bold_option_dropdownmulti,  .product-single__meta .bold_options.bold_options_loaded .bold_option.bold_option_swatch, .product-single__meta .bold_options.bold_options_loaded .bold_option.bold_option_radio, .product-single__meta .bold_options.bold_options_loaded .bold_option.bold_option_checkbox, .product-single__meta .bold_options.bold_options_loaded .bold_option.bold_option_checkboxmulti '
      ).each(function () {
        if ($(this).find('span.bold_tooltip').html()) {
          $(this)
            .find('span.bold_option_title')
            .append('<a href="javascript:void(0)"  class="help cta-bold-view-more">View More </a>');
          $(this)
            .find('span.bold_tooltip')
            .after("<div class='bold_tooltip aictv'>" + $(this).find('span.bold_tooltip small').html() + '</br></div>');
          $(this).find('span.bold_tooltip').remove();
        }
      });
    }
  }, 500);

  $('body').on('click', 'a.cta-bold-view-more', function () {
    if ($(this).hasClass('act')) {
      $(this).text('View More ');
      $(this).removeClass('act');
      // $(this).parent().next().slideUp();
      //$(this).parent().next().removeClass("actvv");
    } else {
      //$(this).parent().next().addClass("actvv");
      $(this).text('Hide More ');
      $(this).addClass('act');
      //$(this).parent().next().slideDown();
    }
    if ($(this).parent().parent().find('.bold_tooltip').hasClass('aictv')) {
      $(this).parent().parent().find('.bold_tooltip').slideToggle();
    } else {
      $(this).parent().parent().parent().find('.bold_tooltip').slideToggle();
    }
  });

  $('.bold_cart_edit_button').on('click', function () {
    var inter = setInterval(function () {
      if ($('bold_tooltip:nth(0)').hasClass('aictv')) {
        clearInterval(inter);
      } else {
        $('.bold_lightbox form .bold_option').each(function () {
          if ($(this).find('span.bold_tooltip').html()) {
            $(this)
              .find('span.bold_option_title')
              .append('<a href="javascript:void(0)"  class="help cta-bold-view-more">View More </a>');
            $(this)
              .find('span.bold_tooltip')
              .after(
                "<div class='bold_tooltip aictv'>" + $(this).find('span.bold_tooltip small').html() + '</br></div>'
              );
            $(this).find('span.bold_tooltip').remove();
          }
        });
      }
    }, 500);
  });

  if (window.location.href.indexOf('/cart') > -1) {
    console.log('cart script');
    $('.cart__row.th_do_cart_line').each(function () {
      var sku = $(this).data('sku');
      var newlead = $(this)
        .find('.shiprow[data-sku="' + $(this).data('sku') + '"]')
        .data('shippmsg');

      console.log(sku + ' ' + newlead + ' ' + textlead);

      if (newlead == null) {
        newlead = $(this)
          .find('.shiprow[data-mpn="' + $(this).data('mpn') + '"]')
          .data('shippmsg');
      }

      if (newlead == null || $('.shiprow').length == 1) {
        newlead = $(this).find('.simplelt').data('leadtime');
      }

      var textlead = '';

      if (newlead == '1') {
        textlead = '1-3 Days';
      } else if (newlead == '2') {
        textlead = '2-4 Days';
      } else if (newlead == '3') {
        textlead = '3-5 Days';
      } else if (newlead == '4') {
        textlead = '4-6 Days';
      } else if (newlead == '5') {
        textlead = '5-7 Days';
      } else if (newlead == '7') {
        textlead = '7-10 Days';
      } else if (newlead == '14') {
        textlead = '2-3 Weeks';
      } else if (newlead == '21') {
        textlead = '3-4 Weeks';
      } else if (newlead == '28') {
        textlead = '4-6 Weeks';
      } else if (newlead == '42') {
        textlead = '6-8 Weeks';
      } else if (newlead > 0) {
        textlead = newlead + ' Days';
      } else {
        textlead = 'Please contact us for Lead Time';
      }

      if (textlead == 'Please contact us for Lead Time') {
        $('<li class="product-details leadtime">' + textlead + '</li>').insertBefore($(this).find('.cart__remove'));
      } else {
        $('<li class="product-details leadtime">Usually Ships within ' + textlead + '</li>').insertBefore(
          $(this).find('.cart__remove')
        );
      }

      $(this).find('.additional-info').addClass('addinfo');
      $(this).find('.additional-info').insertBefore($(this).find('.cart__remove'));
    });
  }
});
const intervalcoa = setInterval(function () {
  $('.ss-item:not(".pricechecked")').each(function () {
    $(this).addClass('pricechecked');

    if ($(this).attr('result-json').indexOf('calltoorder') > -1) {
      $(this).find('.price--on-sale').html('<div class="coalink">Call to Order</div>');
    }
  });
}, 500);

$(document).on('click', '.coalink', function () {
  $('#coa-pop').show();
  $('#coa-overlay').show();
});
$(document).on('click', '#coa-close, #coa-overlay, .coa-chat', function () {
  $('#coa-pop').hide();
  $('#coa-overlay').hide();
});
